define("calendar/controllers/notes/edit", ["exports", "ember-concurrency/async-arrow-runtime", "@ember/controller", "@ember/object", "@ember/service", "@glimmer/tracking", "ember-concurrency"], function (_exports, _asyncArrowRuntime, _controller, _object, _service, _tracking, _emberConcurrency) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"@ember/controller",0,"@ember/object",0,"@ember/service",0,"@glimmer/tracking",0,"ember-concurrency"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let EditController = _exports.default = (_dec = (0, _service.inject)('note'), (_class = class EditController extends _controller.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "dialogManager", _descriptor, this);
      _initializerDefineProperty(this, "errors", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "noteService", _descriptor4, this);
      _initializerDefineProperty(this, "note", _descriptor5, this);
      _initializerDefineProperty(this, "noteContent", _descriptor6, this);
      _initializerDefineProperty(this, "color", _descriptor7, this);
      _defineProperty(this, "cancelUpdate", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          yield this.noteService.confirmClose.perform(this.hasChanges);
        }
      }), null, "cancelUpdate", null));
      _defineProperty(this, "copyToClipboard", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          yield this.noteService.copyToClipboard.perform(this.noteContent);
        }
      }), null, "copyToClipboard", null));
      _defineProperty(this, "deleteCalendarNote", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const didConfirm = yield this.dialogManager.confirmation(this.intl.t('calendar_notes.confirm_discard'), {
            confirmButton: this.intl.t('shared_words.discard')
          });
          if (!didConfirm) {
            return;
          }
          try {
            yield this.note.destroyRecord();
          } catch (error) {
            this.errors.handleAdapter(error, this.note);
          }
          this.noteService.transitionToCalendar();
        }
      }), null, "deleteCalendarNote", null));
      _defineProperty(this, "updateCalendarNote", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          this.note.set('noteContent', this.noteContent);
          this.note.set('color', this.color);
          try {
            yield this.note.save();
          } catch (error) {
            this.errors.handleAdapter(error, this.note);
          }
          this.noteService.transitionToCalendar();
        }
      }), null, "updateCalendarNote", null));
    }
    get allowSave() {
      return this.noteService.shouldAllowSave(this.noteContent);
    }
    get charactersRemaining() {
      return this.noteService.getCharactersRemaining(this.noteContent);
    }
    get hasChanges() {
      return this.note.noteContent !== this.noteContent || this.note.color !== this.color;
    }
    get showCharacterLimit() {
      return this.noteService.shouldShowCharacterLimit(this.noteContent);
    }
    updateColor(color) {
      this.color = color;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "noteService", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "note", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "noteContent", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "color", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _applyDecoratedDescriptor(_class.prototype, "updateColor", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateColor"), _class.prototype)), _class));
});